<template>
  <div class="layout-common-page d-flex align-items-center">
    <!-- Page content -->
    <div class="page-content">
      <!-- Main content -->
      <div class="content-wrapper">
        <!-- Inner content -->
        <div class="content-inner">
          <router-view></router-view>
        </div>
        <!-- /inner content -->
      </div>
      <!-- /main content -->
    </div>
    <!-- /page content -->
  </div>
</template>

<script>

export default {

};
</script>
<style>
.layout-common-page {
  background-image: url("@/assets/images/backgrounds/reqify_bg_3.jpg"); /* Resmin URL'sini buraya yazın */
  background-size: cover; /* Resmi tüm alana sığacak şekilde boyutlandırır */
  background-repeat: no-repeat; /* Resmin tekrar etmesini engeller */
  background-position: center center; /* Resmi ortalar */
  position: fixed;
  width: 100%;
  height: 100%;
}

</style>
